export default __webpack_public_path__ + "static/media/cMatic.b7d50419.png";